var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.uploadedFileList),function(item){return _c('div',{key:item.guid,staticStyle:{"color":"rgb(64, 158, 255)","cursor":"pointer"},on:{"click":function($event){return _vm.download(item.guid,item.fileName)}}},[_c('span',{staticStyle:{"margin-right":"20px"}},[_vm._v("点击下载")]),_c('span',[_vm._v(_vm._s(item.fileName))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }